import React from 'react';

const PersonalInfoTab = ({ person, updateField }) => {
  return (
    <div className="max-w-4xl mx-auto space-y-6 p-4">
      {/* Basic Info Card */}
      <div className="tech-card p-6">
        <h3 className="tech-section-title mb-4 flex items-center gap-2">
          <svg className="w-5 h-5 text-tech-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          BASIC INFORMATION
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-2">NAME</label>
            <input
              type="text"
              value={person.name || ''}
              onChange={(e) => updateField('name', e.target.value)}
              className="tech-input"
            />
          </div>
          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-2">NICKNAME</label>
            <input
              type="text"
              value={person.nickname || ''}
              onChange={(e) => updateField('nickname', e.target.value)}
              className="tech-input"
            />
          </div>
          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-2">USERNAME</label>
            <input
              type="text"
              value={person.username || ''}
              onChange={(e) => updateField('username', e.target.value)}
              className="tech-input"
            />
          </div>
          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-2">BIRTH DATE</label>
            <input
              type="text"
              value={person.birthDate || ''}
              onChange={(e) => updateField('birthDate', e.target.value)}
              placeholder="DD.MM.YYYY"
              className="tech-input"
            />
          </div>
          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-2">AGE</label>
            <input
              type="number"
              value={person.age || ''}
              onChange={(e) => updateField('age', parseInt(e.target.value) || 0)}
              className="tech-input"
            />
          </div>
          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-2">GENDER</label>
            <select
              value={person.gender || ''}
              onChange={(e) => updateField('gender', e.target.value)}
              className="tech-input"
            >
              <option value="">--</option>
              <option value="Male">MALE</option>
              <option value="Female">FEMALE</option>
              <option value="Other">OTHER</option>
            </select>
          </div>
        </div>
      </div>

      {/* Contact Info Card */}
      <div className="tech-card p-6">
        <h3 className="tech-section-title mb-4 flex items-center gap-2">
          <svg className="w-5 h-5 text-tech-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          CONTACT
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-2">EMAIL</label>
            <input
              type="email"
              value={person.email || ''}
              onChange={(e) => updateField('email', e.target.value)}
              className="tech-input"
            />
          </div>
          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-2">PHONE</label>
            <input
              type="tel"
              value={person.phone || ''}
              onChange={(e) => updateField('phone', e.target.value)}
              className="tech-input"
            />
          </div>
        </div>
      </div>

      {/* Address Card */}
      <div className="tech-card p-6">
        <h3 className="tech-section-title mb-4 flex items-center gap-2">
          <svg className="w-5 h-5 text-tech-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          LOCATION
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="md:col-span-2">
            <label className="block text-xs font-mono text-tech-textMuted mb-2">STREET</label>
            <input
              type="text"
              value={person.street || ''}
              onChange={(e) => updateField('street', e.target.value)}
              className="tech-input"
            />
          </div>
          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-2">ZIP</label>
            <input
              type="text"
              value={person.zip || ''}
              onChange={(e) => updateField('zip', e.target.value)}
              className="tech-input"
            />
          </div>
          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-2">CITY</label>
            <input
              type="text"
              value={person.city || ''}
              onChange={(e) => updateField('city', e.target.value)}
              className="tech-input"
            />
          </div>
          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-2">COUNTRY</label>
            <input
              type="text"
              value={person.country || ''}
              onChange={(e) => updateField('country', e.target.value)}
              className="tech-input"
            />
          </div>
          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-2">LATITUDE</label>
            <input
              type="text"
              value={person.latitude || ''}
              onChange={(e) => updateField('latitude', e.target.value)}
              placeholder="51.5074"
              className="tech-input"
            />
          </div>
          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-2">LONGITUDE</label>
            <input
              type="text"
              value={person.longitude || ''}
              onChange={(e) => updateField('longitude', e.target.value)}
              placeholder="-0.1278"
              className="tech-input"
            />
          </div>
        </div>
      </div>

      {/* Additional Info Card */}
      <div className="tech-card p-6">
        <h3 className="tech-section-title mb-4 flex items-center gap-2">
          <svg className="w-5 h-5 text-tech-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          ADDITIONAL
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-2">EYE COLOR</label>
            <input
              type="text"
              value={person.eyeColor || ''}
              onChange={(e) => updateField('eyeColor', e.target.value)}
              className="tech-input"
            />
          </div>
          <div>
            <label className="block text-xs font-mono text-tech-textMuted mb-2">HEIGHT</label>
            <input
              type="text"
              value={person.height || ''}
              onChange={(e) => updateField('height', e.target.value)}
              placeholder="180cm"
              className="tech-input"
            />
          </div>
          <div className="md:col-span-2">
            <label className="block text-xs font-mono text-tech-textMuted mb-2">PROFESSION</label>
            <input
              type="text"
              value={person.profession || ''}
              onChange={(e) => updateField('profession', e.target.value)}
              className="tech-input"
            />
          </div>
          <div className="md:col-span-2">
            <label className="block text-xs font-mono text-tech-textMuted mb-2">DESCRIPTION</label>
            <textarea
              value={person.description || ''}
              onChange={(e) => updateField('description', e.target.value)}
              rows="4"
              className="tech-input resize-none"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfoTab;
